<template>
  <div class="input-group" v-gaEvent="{ category: gacategory, action: gaaction, label: galabel }">
    <input
      :type="'text'"
      :id="id"
      :autocomplete="'off'"
      :disabled="disabled"
      required
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      v-currency:AUD="value"
      min="0"
      oninput="validity.valid||(value='');"
    />
    <label :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "InputPriceField",
  components: {},
  model: {
    prop: "model",
    event: "change"
  },
  props: {
    id: {
      type: String,
      required: true
    },
    model: {
      default: undefined
    },
    value: null,
    disabled: {
      type: Boolean,
      required: false
    },
    gacategory: {
      required: false,
      default: "Dezi Component - Input field"
    },
    gaaction: {
      required: false,
      default: "Clicked Input"
    },
    galabel: {
      required: false,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  },
  watch: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.input-group {
  position: relative;
  width: auto;

  label {
    position: absolute;
    top: 2px;
    left: 8px;
    @apply ut-text-neutral300;
    transition: 0.2s all;
    background-color: #ffffff;
    cursor: text;
    line-height: 18px;
    @apply ut-mt-3 ut-px-2 ut-text-base;
  }

  input {
    border: 0;
    outline: 0;
    // border-bottom: 1px solid #d3d3d3;
    box-shadow: none;
    @apply ut-text-base ut-text-neutral900 ut-w-full;
    appearance: none;
    width: -moz-available;
    width: -webkit-fill-available;
    width: stretch;
    border-radius: 4px;
    border-color: #ccc;
    @apply ut-border ut-border-solid;
    @apply ut-p-3;
    outline: none;
    transition: all 0.2s ease-in;

    &:invalid {
      outline: 0;
    }

    &:focus {
      @apply ut-border-green400;
      transition: all 0.2s ease-in;
    }
    &:valid {
      transition: all 0.2s ease-in;
      @apply ut-border-green400;
    }
  }

  input:focus ~ label {
    top: -18px;
    line-height: 12px;
    @apply ut-text-green400 ut-text-sm;
  }

  input:valid ~ label {
    top: -18px;
    line-height: 12px;
    @apply ut-text-green400 ut-text-sm;
  }
}
</style>
